<div *ngIf="showheader == true">
  <div class="header-context-menu-bar-mobile"  (click)="openContext()">
    <span id="title-context" >
      <img src="./assets/img/swicth.svg" alt="{{ 'contextChange.TITLE' | translate }}" />
      {{ 'contextChange.TITLE' | translate }}
    </span>
  </div>
  <div class="header-container" id="header">
    <div class="container flex-no-wrap base-header" id="headerArea">
      <div id="headerLogoContainer" class="logo-container">
       
        <img
          id="img_logo"
          class="itau_logo"
          src="./assets/img/new-brand.png"
          alt="Itaú logo"
          [attr.tabindex]="initialTabindex"
          attr.aria-label="{{'logo.TITLE' | translate}}"
        />

        <img
            id="img_logo_mobile"
            class="itau_logo"
            src="./assets/img/favicon-32x32.png"
            alt="Itaú mobile logo"
            [attr.tabindex]="initialTabindex"
            attr.aria-label="{{'logo.TITLE' | translate}}"
        />
      </div>

      <div id="headerSearchBarContainer" class="search-bar-container w-40">
        <app-search-bar [initialTabindex]="initialTabindex" (isFocused)="onIsFocused($event)"></app-search-bar>
      </div>

      <div id="headerControlsContainer" class="controls-container">
        <div class="notifications hidden">
          <em class="icon-bell" title="{{ 'notify.TITLE' | translate }}"></em>
        </div>
        <div class="bookmarked-items hidden">
          <em class="icon-star" title="{{ 'favorite.TITLE' | translate }}"></em>
        </div>
        <app-context-configuration></app-context-configuration>
        <app-user-profile-container title="{{ 'userProfile.TITLE' | translate }}"></app-user-profile-container>
        <app-burger-menu [menu]="menu"></app-burger-menu>
      </div>

    </div>
    <app-menu [intitialMenuTabIndex]="initialTabindex+1" [attr.tabindex]="initialTabindex+1" [searchBarIsFocused]="searchBarIsFocused" (menuRetrieval)="onMenuRetrieval($event)"></app-menu>


  </div>
  <app-itau-modal [logo]="false" [show]="contextOpen" [title]="'contextChange.TITLE' | translate" (close)="onCloseContext($event)"><app-context></app-context></app-itau-modal>
</div>
